<template>
  <div class="video-management big">
    <div class="page_title">视频管理</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="between"
             style="margin-bottom: 20px">
          <div class="search-box">
            <div class="item">
              <span>视频名称</span>
              <div class="item-content">
                <el-input v-model="searchForm.video_title"
                          size="small"
                          clearable
                          @keyup.enter.native="seachEnterFun"
                          placeholder="请输入"></el-input>
              </div>
              <el-button type="primary"
                         size="small"
                         style="margin-left:20px"
                         @click="getList">查询</el-button>
            </div>

          </div>

          <el-button type="primary"
                     icon="el-icon-plus"
                     @click="addVideo">新增</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="doctorTableRef"
                    class="doctor-table"
                    v-loading="tableLoading"
                    :data="doctorTableData"
                    @sort-change="changeSort"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column v-for="item in tableHeader"
                             align="center"
                             :key="item.prop"
                             :label="item.label"
                             :prop="item.prop"
                             :width="item.width"
                             :fixed="item.fixed"
                             :sortable="item.sortable">
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'video_url_str'">
                  <UploadVideo videoBaseUrl=""
                               :isDel="false"
                               :videos="[{
                                video_url_str:scope.row[item.prop],isShowPopup:false
                               }]">

                  </UploadVideo>
                </div>
                <div v-else-if="item.prop == 'mian_url_str'">
                  <el-image style="width: 100px; height: 100px"
                            :src="scope.row[item.prop]"
                            :preview-src-list="[scope.row[item.prop]]">
                  </el-image>
                </div>
                <div v-else-if="item.prop == 'real_like'">
                  {{ scope.row[item.prop] }} / {{ scope.row['virtually_like'] }}
                </div>
                <div v-else-if="item.prop == 'real_share'">
                  {{ scope.row[item.prop] }} / {{ scope.row['virtually_share'] }}
                </div>
                <div v-else-if="item.prop == 'real_collect'">
                  {{ scope.row[item.prop] }} / {{ scope.row['virtually_collect'] }}
                </div>
                <div v-else-if="item.prop == 'video_desc'">
                  <el-tooltip class="item"
                              effect="dark"
                              :content="scope.row[item.prop]"
                              placement="top">
                    <div class="text-ellipsis"
                         style="width:200px">{{ scope.row[item.prop] }}</div>
                  </el-tooltip>
                </div>

                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="140px"
                             align="center"
                             fixed='right'>
              <template slot-scope="scope">
                <el-button @click="editBtn(scope.row.video_id)"
                           type="text"
                           :disabled="module_id_array[0]? !module_id_array.includes('1607'): false"
                           size="medium">编辑</el-button>
                <el-button @click="delBtn(scope.row.video_id)"
                           type="text"
                           :disabled="module_id_array[0]? !module_id_array.includes('1608'): false"
                           size="medium">删除</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <pagination v-show="totalNum > 0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </div>
    </div>

  </div>
</template>
<script>
import imgtext from '@/api/imgtext';
import Pagination from '../../../components/Pagination/index';
import dayjs from 'dayjs';
import VideoPlay from '@/components/videoPlay/index.vue';
import UploadVideo from '@/components/uploadVideo/index';
export default {
  components: {
    Pagination,
    UploadVideo
  },
  data() {
    return {
      tableHeader: [
        {
          label: '视频名称',
          prop: 'video_title',
          width: '200',
          sortable: false,
          fixed: 'left'
        },
        {
          label: '创建时间',
          prop: 'create_time',
          width: '140',
          sortable: false,
          fixed: false
        },
        {
          label: '视频',
          prop: 'video_url_str',
          width: '100px',
          sortable: false,
          fixed: false
        },
        {
          label: '封面',
          prop: 'mian_url_str',
          width: '200px',
          sortable: false,
          fixed: false
        },
        {
          label: '关联医生',
          prop: 'doctor_list_str',
          width: '200',
          sortable: false,
          fixed: false
        },
        {
          label: '关联疾病',
          prop: 'goodAt_list_str',
          width: '200',
          sortable: false,
          fixed: false
        },
        {
          label: '点赞数/虚拟点赞数',
          prop: 'real_like',
          width: '160',
          sortable: true,
          fixed: false
        },
        {
          label: '分享数/虚拟分享数',
          prop: 'real_share',
          width: '160',
          sortable: true,
          fixed: false
        },
        {
          label: '收藏数/虚拟收藏数',
          prop: 'real_collect',
          width: '160',
          sortable: true,
          fixed: false
        },
        {
          label: '浏览量',
          prop: 'read_num',
          width: 'auto',
          sortable: false,
          fixed: false
        },
        {
          label: '视频简介',
          prop: 'video_desc',
          width: '160',
          sortable: false,
          fixed: false
        }
      ],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      doctorTableData: [],
      searchForm: {
        video_title: '',
        prop: '',
        by: ''
      }
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //获取报表列表
    getList() {
      this.tableLoading = true;
      let params = Object.assign({}, this.searchForm, this.pagination);
      imgtext
        .getVideoList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.totalNum = data.total;
            this.doctorTableData = data.list;
          }
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    // 拍寻
    changeSort(value) {
      console.log(value);
      let sortType = value.order;
      this.searchForm.prop = value.prop;
      switch (sortType) {
        case 'ascending':
          this.searchForm.by = 'asc';
          break;
        case 'descending':
          this.searchForm.by = 'desc';
          break;

        default:
          this.searchForm.by = '';
          this.searchForm.prop = '';
          break;
      }
      this.getList();
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    addVideo() {
      this.$router.push({
        path: '/home/imgtext/addAndEditVideo',
        query: {
          video_id: -99
        }
      });
    },
    // 编辑
    editBtn(video_id) {
      this.$router.push({
        path: '/home/imgtext/addAndEditVideo',
        query: {
          video_id
        }
      });
    },
    // 删除
    delBtn(video_id) {
      this.$confirm('确认删除当前视频吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        imgtext.deleteVideo({ video_id }).then((res) => {
          let { code } = res;
          if (code == 0) {
            this.$message.success('删除成功');
            this.getList();
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" >
.video-management {
  .container {
    box-sizing: border-box;
    background-color: #ffffff;
    min-height: calc(100vh - 140px);
    padding: 20px;
    text-align: left;
  }
  .pagination-container {
    display: flex;
    justify-content: center;
  }
}
.search-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      margin-right: 4px;
      text-align: right;
      white-space: nowrap;
      box-sizing: border-box;
    }
  }
  .item-content {
    // width: 100%;
    .el-date-editor {
      width: 100%;
    }
  }
}
</style>

